import './Welcome.css';
import Inline from '../Inline';
import { isMobile } from 'react-device-detect';

const Welcome = (props) => {
  const handleServicesClick = () => {
    const servicesSection = document.getElementById('services');
    servicesSection?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleLoginClick = () => {
    props.onEnter?.();
    // window.location.href = '/login' for actual routing
  };

  const mo = isMobile;

  return (
    <div className="parssaman2-container">
      {/* Header */}
      <header className="parssaman2-header">
        <h1>گروه پارس سامان</h1>
        <nav>
          <ul>
            <li><a href="#about">درباره ما</a></li>
            <li><a href="#services">خدمات</a></li>
            <li><a href="#contact">تماس</a></li>
          </ul>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="parssaman2-hero">
        <h2>ارسال بار با سرعت و اطمینان</h2>
        <p>با ناوگانی مجهز، رانندگان حرفه‌ای و سامانه رهگیری آنلاین، بار شما را در کمترین زمان و با بیشترین امنیت به مقصد می‌رسانیم.</p>
        <div className="parssaman2-btn-group">
          <button className="parssaman2-btn" onClick={handleServicesClick}>
            مشاهده خدمات
          </button>
          <button className="parssaman2-btn parssaman2-btn-outline" onClick={handleLoginClick}>
            ورود
          </button>
        </div>
      </section>

      <Inline style={{ alignItems: 'stretch' }}>
        <div style={{ width: '50%' }}>
          {/* About Section */}
          <section id="about" className="parssaman2-section"
            style={{
              margin: mo ? '0 5px' : '0 1rem', borderRadius: mo ? '0.5em 0.5em 0 0' : '1rem 1rem 0 0',
              height: mo ? '300px' : '500px', overflowY: 'scroll', scrollbarWidth: 'thin',
              flex: '1', fontSize: mo && '0.85em',
            }}>
            <h3 style={{ fontSize: mo && '1.1rem' }}>شرکت خدمات حمل پارس آرتان</h3>
            <br />
            <p style={{ textAlign: 'justify', fontSize: mo && '0.85em' }}>
              شرکت
              &nbsp;
              <span style={{ color: 'white', fontWeight: '900', fontSize: mo && '0.85em' }}>
                پارس آرتان
              </span>&nbsp;
              با سال‌ها تجربه در زمینه حمل و نقل تخصصی مواد شیمیایی، به‌ویژه اسید کلریدریک، آب ژاول و سایر مواد خطرناک صنعتی، به‌عنوان یکی از شرکت‌های معتبر در این حوزه شناخته می‌شود.
              ما با در اختیار داشتن ناوگانی مجهز از تانکرهای استیل و پلی‌اتیلن استاندارد و همکاری با رانندگان آموزش‌دیده و مجرب، حمل ایمن و به‌موقع مواد شیمیایی را از کارخانه‌های تولیدی تا مقصد نهایی تضمین می‌کنیم.
              <br />
              هدف ما در پارس آرتان، ایجاد اعتماد، سرعت و ایمنی در زنجیره تأمین مواد شیمیایی است تا مشتریان با اطمینان کامل بتوانند بر فرآیند تولید و تجارت خود تمرکز کنند.
            </p>
          </section>

          {/* Services Section */}
          <section id="services" className="parssaman2-section"
            style={{ margin: mo ? '0 5px' : '0 1rem', borderRadius: mo ? '0 0 0.5em 0.5em' : '0 0 1rem 1rem' }}>
            <h3 style={{ fontSize: mo && '1.2em' }}>خدمات </h3>
            <p style={{ fontSize: mo && '0.85em' }}>ما مجموعه‌ای کامل از خدمات حمل‌ونقل را برای پاسخ به نیازهای مختلف مشتریان ارائه می‌دهیم.</p>
            <div className="parssaman2-services">
              <div className="parssaman2-service-card">
                <h4 style={{ fontSize: mo && '1.1em' }}>
                  زمینه فعالیت
                </h4>
                <p style={{ fontSize: mo && '0.85em' }}>
                  حمل و جابجایی انواع اسیدها و مواد قلیایی به‌صورت فله و بسته‌بندی‌شده
                </p>
              </div>
              <div className="parssaman2-service-card">
                <h4 style={{ fontSize: mo && '1.1em' }}>
                  شرح خدمات
                </h4>
                <p style={{ fontSize: mo && '0.85em' }}>
                  سرویس‌دهی منظم بین کارخانه‌های پتروشیمی، صنایع پایین‌دستی و واحدهای صنعتی
                </p>
              </div>
              <div className="parssaman2-service-card">
                <h4 style={{ fontSize: mo && '1.1em' }}>
                  کیفیت خدمت رسانی
                </h4>
                <p style={{ fontSize: mo && '0.85em' }}>
                  رعایت کامل استانداردهای ایمنی، زیست‌محیطی و دستورالعمل‌های حمل مواد خطرناک
                </p>
              </div>
              <div className="parssaman2-service-card">
                <h4 style={{ fontSize: mo && '1.1em' }}>
                  گستره فعالیت
                </h4>
                <p style={{ fontSize: mo && '0.85em' }}>
                  ارائه خدمات حمل درون‌استانی و برون‌استانی
                </p>
              </div>
              <div className="parssaman2-service-card">
                <h4 style={{ fontSize: mo && '1.1em' }}>
                  خدمات ویژه
                </h4>
                <p style={{ fontSize: mo && '0.85em' }}>
                  بیمه کامل محموله‌ها در طول مسیر
                </p>
              </div>
            </div>
            <br />
          </section>
        </div>
        <div style={{ width: '50%' }}>
          {/* About Section */}
          <section id="about" className="parssaman2-section"
            style={{
              margin: mo ? '0 5px' : '0 1rem', borderRadius: mo ? '0.5em 0.5em 0 0' : '1rem 1rem 0 0',
              height: mo ? '300px' : '500px', overflowY: 'scroll', scrollbarWidth: 'thin'
            }}>
            <h3 style={{ fontSize: mo && '1.1rem' }}>شرکت فنی و بازرگانی سامان ارمغان ماهشهر صنعت </h3>
            {/*             
            <h4>
              <b>
                فنی و بازرگانی سامان ارمغان ماهشهر صنعت
              </b>
            </h4> */}
            <br />
            <p style={{ textAlign: 'justify', fontSize: '0.85em' }}>
              شرکت
              &nbsp;
              <span style={{ color: 'white', fontWeight: '900', fontSize: '0.85em' }}>
                سامان ارمغان ماهشهر صنعت
              </span>&nbsp;
              با تکیه بر تجربه، تخصص و رویکردی نوین در صنعت، فعالیت خود را در دو حوزه‌ی اصلی تأمین مواد شیمیایی صنعتی و خدمات فنی و عمرانی آغاز کرده و با گسترش دامنه‌ی فعالیت‌ها، به یکی از شرکت‌های توانمند منطقه جنوب کشور تبدیل شده است.
              <br />
              🔹 تأمین و بازرگانی مواد شیمیایی
              <br />
              این شرکت به‌عنوان یکی از تأمین‌کنندگان معتبر مواد شیمیایی صنعتی، در زمینه‌ی تأمین و توزیع انواع مواد از جمله اسید کلریدریک، آب ژاول، سود سوزآور، نیترات‌ها و سایر ترکیبات پرکاربرد در صنایع پتروشیمی، آب و فاضلاب و کشاورزی فعالیت دارد.
              تمامی مواد تحت نظارت دقیق کنترل کیفی تهیه شده و حمل آن‌ها با استفاده از تانکرهای استاندارد و ناوگان حمل اختصاصی شرکت انجام می‌شود تا سلامت و ایمنی محموله در تمام مراحل تضمین گردد.
              <br />
              🔹 خدمات فنی، اجرایی و ساخت‌وساز
              <br />
              در کنار فعالیت‌های بازرگانی، شرکت سامان ارمغان ماهشهر صنعت با بهره‌گیری از تیمی متخصص در حوزه‌های عمران، مکانیک و تأسیسات صنعتی، خدمات گسترده‌ای در زمینه‌های زیر ارائه می‌دهد:
              <p style={{ padding: mo ? '0 10px 0 0' : '0 2rem 0 0' }}>
                •	اجرای پروژه‌های ساخت و ساز صنعتی و عمرانی
                <br />
                •	طراحی و اجرای مخازن ذخیره مواد شیمیایی
                <br />
                •	تعمیر و نگهداری خطوط انتقال و تجهیزات صنعتی
                <br />
                •	تأمین و نصب سازه‌ها و زیرساخت‌های مرتبط با صنایع شیمیایی
              </p>
              <p>
                هدف ما در سامان ارمغان ماهشهر صنعت، ایجاد پیوندی مطمئن میان تأمین، حمل و اجرای پروژه‌های صنعتی است؛ به‌گونه‌ای که مشتریان بتوانند تمامی نیازهای خود را از یک مجموعه‌ی متخصص، مطمئن و مسئولیت‌پذیر دریافت کنند
              </p>

            </p>
          </section>

          {/* Services Section */}
          <section id="services" className="parssaman2-section"
            style={{ margin: mo ? '0 5px' : '0 1rem', borderRadius: mo ? '0 0 0.5em 0.5em' : '0 0 1rem 1rem' }}>
            <h3 style={{ fontSize: mo && '1.2em' }}>خدمات </h3>
            <p style={{ fontSize: mo && '0.85em' }}>ما مجموعه‌ای کامل از خدمات فنی، تأمین و اجرا بنا به درخواست مشتریان ارائه می‌دهیم.</p>
            <div className="parssaman2-services" style={{ flexDirection: mo && 'row' }}>
              <div className="parssaman2-service-card">
                <h4 style={{ fontSize: mo && '1.1em' }}>
                  تأمین و بازرگانی مواد شیمیایی
                </h4>
                <p style={{ fontSize: mo && '0.85em' }}>
                  اسید کلریدریک، آب ژاول، سود سوزآور، نیترات‌ها و سایر ترکیبات پرکاربرد
                </p>
              </div>
              <div className="parssaman2-service-card">
                <h4 style={{ fontSize: mo && '1.1em' }}>
                  گستره فعالیت
                </h4>
                <p style={{ fontSize: mo && '0.85em' }}>
                  صنایع پتروشیمی، آب و فاضلاب و کشاورزی
                </p>
              </div>
              <div className="parssaman2-service-card" style={{ width: 'calc(520px + 1.5em)' }}>
                <h4 style={{ fontSize: mo && '1.1em' }}>
                  خدمات فنی، اجرایی و ساخت‌وساز
                </h4>
                <p style={{ fontSize: mo && '0.85em' }}>
                  اجرای پروژه‌های ساخت و ساز صنعتی و عمرانی
                  <br />طراحی و اجرای مخازن ذخیره مواد شیمیایی
                  <br />تعمیر و نگهداری خطوط انتقال و تجهیزات صنعتی
                  <br /> تأمین و نصب سازه‌ها و زیرساخت‌های مرتبط با صنایع شیمیایی
                </p>
              </div>

            </div>
            <br />

          </section>
        </div>


      </Inline>
      {/* Contact Section */}
      <section id="contact" className="parssaman2-section">
        <h3>تماس با ما</h3>
        <p>برای دریافت اطلاعات بیشتر، مشاوره یا همکاری با ما تماس بگیرید:</p>
        <p>
          تلفن:
          ۰۹۳۶۱۳۸۴۰۵۸ -    ۰۹۱۲۰۶۸۲۶۶۹ - ۰۹۱۶۹۹۵۷۳۳۱
          📞
          <br />
          ایمیل:
          amotayyeri@gmail.com
          ✉
          <br />
          آدرس:
          خوزستان، بندر ماهشهر، فاز ۵، بلوار دانشجو، ساختمان جواهر، طبقه ۳ واحد ۱۷
          🏠
        </p>
      </section>

      {/* Footer */}
      <footer className="parssaman2-footer">
        <p>© ۲۰۲۵ شرکت حمل‌ونقل سریع. تمامی حقوق محفوظ است.</p>
      </footer>
    </div>
  );
};

export default Welcome;